// Can be used as CSS classed to modify templates
// most views have a sidebar, a few do not, e.g. Caches
export enum Layout {
  HAS_SIDEBAR = "has-sidebar",
  IS_FULL_WIDTH = "is-full-width",
}
